import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { createPinia } from 'pinia';
import { useAuthStore } from './store/auth';
import { useConfigStore } from './store/config';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faCircle, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { faWindows, faApple, faCcVisa, faCcMastercard, faCcAmex, faCcDiscover, faCcDinersClub, faCcJcb } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Service } from './services/service';
import VueCreditCardValidation from 'vue-credit-card-validation';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { defineRule } from 'vee-validate';

library.add(faEye);
library.add(faCircle);
library.add(faWindows);
library.add(faApple);
library.add(faCcVisa);
library.add(faCcMastercard);
library.add(faCcAmex);
library.add(faCcDiscover);
library.add(faCcDinersClub);
library.add(faCcJcb);
library.add(faCreditCard);

async function start() {
    const pinia = createPinia();

    const app = createApp(App)
        .component('font-awesome-icon', FontAwesomeIcon)
        .use(pinia)

    const config = useConfigStore();
    const auth = useAuthStore();

    Service.init(auth.logout);

    await config.getConfig();
    await auth.initialize();

    app
        .use(router)
        .use(VueCreditCardValidation)
        .mount('#app');

    const cardValidator = app.config.globalProperties.$cardFormat;

    defineRule("required", (value: string) => {
        if (!value || !value.length) {
            return "This field is required";
        }
        return true;
    });
    defineRule("email", (email: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!email || !re.test(email.toLowerCase())) {
            return "Should be a valid email";
        } else {
            return true;
        }
    });
    defineRule("password", (password: string) => {
        if (password.length < 8) {
            return "Password should be at least 8 character length";
        }
        return true;
    });
    defineRule("confirmed", (value, [target]: [any], ctx) => {
        if (value === ctx.form[target]) {
            return true;
        }
        return "Passwords doesn't match";
    });
    defineRule("phone", (phone: string) => {
        if (!/^[0-9-]+$/i.test(phone)) {
            return "This field should contains phone";
        }
        return true;
    });
    defineRule("code", (code: string) => {
        if (!/^[0-9]+$/i.test(code)) {
            return "This field should contain numbers only";
        }
        return true;
    });
    defineRule("card-number", (value: string) => {
        if (!cardValidator.validateCardNumber(value)) {
            return "Invalid Card Number";
        }
        return true;
    });
    defineRule("card-expiration", (value: string) => {
        if (!cardValidator.validateCardExpiry(value)) {
            return "Invalid Expiration Date";
        }
        return true;
    });
    defineRule("card-cvc", (value: string) => {
        if (!cardValidator.validateCardCVC(value)) {
            return "Invalid CVC";
        }
        return true;
    });
}

start();